import { useState } from 'react'
import Sidebar from '../components/Sidebar'
import Graph from '../components/Chart'
import Legend from '../components/Legend'
import Table from '../components/Table'
import 'reactjs-popup/dist/index.css';
import '../styling/sidebar.css'
import {Container, Row, Col} from 'react-bootstrap'
import Mode from '../components/Mode'
function TimeCalc() {
    const [sidebar, setSidebar] = useState(false);
    return (
        <>
        <Container fluid>
            <Row>
                <Col md = {2}>
                <Sidebar sidebar={sidebar} setSidebar={setSidebar}></Sidebar>
                    </Col> 
                <Col>
                    <Row>
                        <div className = 'overview'>Time Calculator</div>
                    </Row>
                </Col>
            </Row>
        </Container>
        <Mode/>
        </ >
    );
  }
  
  export default TimeCalc;
